import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Typography, Checkbox } from 'antd';
import './MapLegend.css';

const { Text } = Typography;

const MapLegend = ({ mapLegendList, showFilter, onSelectionChange }) => {
  const allTitles = mapLegendList?.map(item => item.title) || [];
  const [selectedItems, setSelectedItems] = useState(allTitles);

  useEffect(() => {
    setSelectedItems(allTitles);
  }, [mapLegendList]);

  const handleCheckboxChange = (title, checked) => {
    let updated;
    if (checked) {
      updated = [...selectedItems, title];
    } else {
      updated = selectedItems.filter(item => item !== title);
    }
    setSelectedItems(updated);
    if (onSelectionChange) onSelectionChange(updated);
  };

  const handleShowAllChange = e => {
    const checked = e.target.checked;
    const updated = checked ? allTitles : [];
    setSelectedItems(updated);
    if (onSelectionChange) onSelectionChange(updated);
  };

  return (
    <Flex
      className={
        showFilter ? 'map-legend-container-right' : 'map-legend-container'
      }
      gap={14}
      vertical
      wrap="wrap"
      align="flex-start"
      style={{ maxWidth: '60%' }}
    >
      <Flex align="center" gap={8}>
        <Checkbox
          checked={selectedItems.length === allTitles.length}
          indeterminate={
            selectedItems.length > 0 && selectedItems.length < allTitles.length
          }
          onChange={handleShowAllChange}
          style={{ transform: 'scale(0.75)' }}
        />
        <Text className="legend-text"> Show All</Text>
      </Flex>
      {mapLegendList?.map(legendItem => (
        <Flex key={legendItem.title} align="center" gap={8}>
          <Checkbox
            checked={selectedItems.includes(legendItem.title)}
            onChange={e =>
              handleCheckboxChange(legendItem.title, e.target.checked)
            }
            style={{ transform: 'scale(0.75)' }}
          />
          <img
            src={legendItem.icon}
            alt={legendItem.title}
            style={{
              height: legendItem.size.height,
              width: legendItem.size.width,
            }}
            className="legend-icon"
          />
          <Text className="legend-text">{legendItem.title}</Text>
        </Flex>
      ))}
    </Flex>
  );
};

MapLegend.propTypes = {
  mapLegendList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      size: PropTypes.shape({
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
    })
  ),
  showFilter: PropTypes.bool,
  onSelectionChange: PropTypes.func,
};

export default MapLegend;
